import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { toastError, toastSuccess } from '@components/Toast';

import { findUserBySearch } from '@services/commonService';

import ApiClient from '@lib/apiClient';

import { capitalizeFirstLetter } from '@utils/Util';

const AddAdmin = () => {
	const [email, setEmail] = useState('');
	const [fullName, setFullName] = useState('');
	const [nickName, setNickName] = useState('');
	const [status, setStatus] = useState('ACTIVE');
	const [designation, setDesignation] = useState('');
	const [allRoleData, setAllRoleData] = useState([]);
	const [roleList, setRoleList] = useState([]);
	const [role, setRole] = useState('');
	const [departmentList] = useState([]);
	const [isManagement, setIsManagement] = useState(false);
	const [department, setDepartment] = useState([]);
	const [countryList, setCountryList] = useState([]);
	const [operationalZone, setOperationalZone] = useState([]);
	const [phoneNumber, setPhoneNumber] = useState('');
	const [linkedinProfile, setLinkedinProfile] = useState('');
	const [workStation, setWorkStation] = useState('');
	const [officeAddressList, setOfficeAddressList] = useState([]);
	const [officeAddress, setOfficeAddress] = useState('');
	const [employeeAddress, setEmployeeAddress] = useState('');
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [error, setError] = useState({});
	const [teamLeadList, setTeamLeadList] = useState([]);
	const navigate = useNavigate();

	const styles = {
		control: (base) => ({
			...base,
			fontFamily: 'Inter',
			fontSize: '14px'
		}),
		menu: (base) => ({
			...base,
			fontFamily: 'Inter',
			fontSize: '14px'
		})
	};

	useEffect(() => {
		ApiClient.GET('getCountryList').then(({ data }) => {
			let formatData = data.map((item) => ({
				value: item.id,
				label: item.name
			}));
			setCountryList(formatData);
		});

		ApiClient.GET('getRoleWithDepartment').then(({ data }) => {
			let formatData = data.map((item) => ({
				value: item.id,
				label: item.name
			}));
			setRoleList(formatData);
			setAllRoleData(data);
		});

		ApiClient.GET('getCountryListByUnits', 'OFFICE_LOCATION').then(({ data }) => {
			let lists = [];
			data.map((item) => lists.push({ value: item.id, label: capitalizeFirstLetter(item.name) }));
			setOfficeAddressList(lists);
		});
	}, []);

	const onRoleChange = (value) => {
		setRole(value);
		setIsManagement(false);
		if (value) {
			let selectedRole = allRoleData.filter((item) => item.id === value.value)[0];
			setDepartment(
				selectedRole.departmentResponseList?.map((department) => {
					return {
						value: department.id,
						label: department.name
					};
				})
			);

			setIsManagement(selectedRole.isManagement);

			if (selectedRole.isManagement) {
				setOperationalZone(
					selectedRole.countryResponseList?.map((country) => {
						return {
							value: country.id,
							label: country.name
						};
					})
				);
			}
		}
	};

	const validateForm = () => {
		let cloneError = {};
		if (!email) {
			cloneError.email = 'Email is required';
		}
		if (!fullName) {
			cloneError.fullName = 'Full name is required';
		}
		if (!nickName) {
			cloneError.nickName = 'Nick name is required';
		}
		if (!designation) {
			cloneError.designation = 'Designation is required';
		}
		if (!role) {
			cloneError.role = 'Role is required';
		}
		if (!workStation) {
			cloneError.workStation = 'Work Station is required';
		}
		if (!officeAddress) {
			cloneError.officeAddress = 'Office address is required';
		}
		if (operationalZone.length === 0) {
			cloneError.operationalZone = 'Operational zone is required';
		}
		if (!password) {
			cloneError.password = 'Password is required';
		}
		if (!confirmPassword) {
			cloneError.confirmPassword = 'Confirm password is required';
		}
		// if (teamLeadList.length === 0) {
		// 	cloneError.teamLeadError = 'Team lead is required';
		// }
		setError(cloneError);
		return Object.keys(cloneError).filter((key) => cloneError[key] !== undefined).length > 0;
	};

	const handleBlurEvent = (fieldName) => {
		if (fieldName === 'email' && email) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'fullName' && fullName) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'nickName' && nickName) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'designation' && designation) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'role' && designation) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'operationalZone' && operationalZone.length > 0) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'workStation' && workStation) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'officeAddress' && officeAddress) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'password' && password) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'confirmPassword' && confirmPassword) {
			setError({ ...error, [fieldName]: undefined });
		} else if (fieldName === 'teamLeadError' && teamLeadList.length > 0) {
			setError({ ...error, [fieldName]: undefined });
		}
	};

	const addAdminInfo = () => {
		if (!validateForm()) {
			let postObj = {
				email: email,
				password: password,
				retypePassword: confirmPassword,
				fullName: fullName,
				nickName: nickName,
				status: status,
				userLevelId: role.value,
				countryId: workStation.value,
				designation: designation,
				operationalZoneIds: operationalZone.map((country) => country.value),
				phone: phoneNumber,
				linkedin: linkedinProfile,
				address: employeeAddress,
				officeLocationId: officeAddress.value,
				teamLeadIds: teamLeadList
			};
			ApiClient.POST('addAdmin', postObj)
				.then(() => {
					toastSuccess('Successfully added');
					navigate('/admins/list?activeTab=ADMINLIST');
				})
				.catch(() => {
					toastError('Something went wrong!');
				});
		}
	};

	const onReset = () => {
		setEmail('');
		setFullName('');
		setNickName('');
		setStatus('ACTIVE');
		setDesignation('');
		setRole('');
		setDepartment([]);
		setOperationalZone([]);
		setPhoneNumber('');
		setLinkedinProfile('');
		setWorkStation('');
		setOfficeAddress('');
		setEmployeeAddress('');
		setPassword('');
		setConfirmPassword('');
		setTeamLeadList([]);
	};

	const onChangeMultiSelect = (selected) => {
		setTeamLeadList(selected?.map((item) => item?.value));
	};

	const searchUserByName = async (inputValue) => {
		let params = `?page=0&size=100&search=${inputValue}&isNitexUser=true`;
		let response = await findUserBySearch(params);
		return response?.data?.map((item) => ({
			value: item.id,
			label: item.name
		}));
	};

	const promiseOptions = async (inputValue) => {
		return new Promise((resolve) => {
			setTimeout(async () => {
				resolve(await searchUserByName(inputValue));
			}, 1000);
		});
	};

	return (
		<>
			<div className="brand-container role-management-container">
				<div className="form-container">
					<div className="form-header pb-3">
						<p className="semibold-16">Add Admin</p>
					</div>
					<div className="container px-0">
						<div className="row form-row">
							<div className="col-md-12">
								<h3 className="semibold-14">Basic info*</h3>
							</div>
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="email">Email</label>
									<input
										type="email"
										placeholder="Type your email"
										name="email"
										value={email}
										onBlur={() => handleBlurEvent('email')}
										onChange={(e) => setEmail(e.target.value)}
									/>
									{error.email && <p className="error">{error.email}</p>}
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="fullName">Full Name</label>
									<input
										type="text"
										autoComplete="off"
										placeholder="Type your full name"
										name="fullName"
										value={fullName}
										onBlur={() => handleBlurEvent('fullName')}
										onChange={(e) => setFullName(e.target.value)}
									/>
									{error.fullName && <p className="error">{error.fullName}</p>}
								</div>
							</div>

							<div className="col-md-6 pr-10">
								<div className="form-group mb-0">
									<label htmlFor="nickName">Nickname</label>
									<input
										type="text"
										autoComplete="off"
										placeholder="Type your nick name"
										name="nickName"
										value={nickName}
										onBlur={() => handleBlurEvent('nickName')}
										onChange={(e) => setNickName(e.target.value)}
									/>
									{error.nickName && <p className="error">{error.nickName}</p>}
								</div>
							</div>
							<div className="col-md-6 pl-10">
								<div className="form-group mb-0">
									<label htmlFor="Description">Status</label>
									<select
										name="status"
										value={status}
										onChange={(e) => setStatus(e.target.value)}
									>
										<option value="ACTIVE" selected>
											Active
										</option>
										<option value="DISABLED">Disable</option>
									</select>
								</div>
							</div>
						</div>

						<div className="row form-row">
							<div className="col-md-12">
								<h3 className="semibold-14">Job details*</h3>
							</div>
							<div className="col-md-6 pr-10">
								<div className="form-group no-shadow-react-select">
									<label htmlFor="department">Team Lead</label>
									<AsyncSelect
										styles={styles}
										onChange={(selected) => onChangeMultiSelect(selected)}
										onBlur={() => handleBlurEvent('teamLeadError')}
										isMulti
										cacheOptions
										defaultOptions
										loadOptions={promiseOptions}
									/>
									{error.teamLeadError && <p className="error">{error.teamLeadError}</p>}
								</div>
							</div>
							<div className="col-md-6">
								<div className="form-group">
									<label htmlFor="designation">Designation</label>
									<input
										type="text"
										autoComplete="off"
										placeholder="Type your designation"
										name="designation"
										value={designation}
										onBlur={() => handleBlurEvent('designation')}
										onChange={(e) => setDesignation(e.target.value)}
									/>
									{error.designation && <p className="error">{error.designation}</p>}
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group no-shadow-react-select">
									<label htmlFor="role">Role</label>
									<Select
										onChange={onRoleChange}
										onBlur={() => handleBlurEvent('role')}
										name="role"
										value={role}
										isMulti={false}
										options={roleList}
									/>
									{error.role && <p className="error">{error.role}</p>}
								</div>
							</div>

							<div className="col-md-12">
								<div className="form-group no-shadow-react-select">
									<label htmlFor="department">Department</label>
									<Select
										value={department}
										isMulti
										options={departmentList}
										isDisabled={true}
									/>
								</div>
							</div>

							<div className="col-md-12">
								<div className="form-group no-shadow-react-select">
									<label htmlFor="operationalZone">Operational Zone</label>
									<Select
										onChange={setOperationalZone}
										onBlur={() => handleBlurEvent('operationalZone')}
										value={operationalZone}
										name="operationalZone"
										isMulti
										options={countryList}
										isDisabled={isManagement}
									/>
									{error.operationalZone && (
										<p className="error">{error.operationalZone}</p>
									)}
								</div>
							</div>
						</div>

						<div className="row form-row">
							<div className="col-md-12">
								<h3 className="semibold-14">Details Information</h3>
							</div>
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="phoneNumber ">Phone number</label>
									<input
										type="number"
										placeholder="Type your number"
										name="phoneNumber"
										value={phoneNumber}
										onChange={(e) => setPhoneNumber(e.target.value)}
									/>
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="linkedin">Linkedin profile</label>
									<input
										type="text"
										autoComplete="off"
										placeholder="Type your linkedin profile"
										name="linkedin"
										value={linkedinProfile}
										onChange={(e) => setLinkedinProfile(e.target.value)}
									/>
								</div>
							</div>

							<div className="col-md-12">
								<div className="form-group no-shadow-react-select">
									<label htmlFor="workStation">Work Station*</label>
									<Select
										onChange={setWorkStation}
										onBlur={() => handleBlurEvent('workStation')}
										name="workStation"
										value={workStation}
										isMulti={false}
										options={countryList}
									/>
									{error.workStation && <p className="error">{error.workStation}</p>}
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group no-shadow-react-select">
									<label htmlFor="officeAddress">Office Address*</label>
									<Select
										onChange={setOfficeAddress}
										onBlur={() => handleBlurEvent('officeAddress')}
										value={officeAddress}
										name="operationalZone"
										isMulti={false}
										options={officeAddressList}
									/>

									{error.officeAddress && <p className="error">{error.officeAddress}</p>}
								</div>
							</div>

							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="employeeAddress">Employee Address</label>
									<textarea
										name="employeeAddress"
										value={employeeAddress}
										onChange={(e) => setEmployeeAddress(e.target.value)}
										placeholder="Type employee address"
									/>
								</div>
							</div>
						</div>

						<div className="row form-row">
							<div className="col-md-12">
								<h3 className="semibold-14">Set Password*</h3>
							</div>
							<div className="col-md-6 pr-10">
								<div className="form-group">
									<label htmlFor="password">Password</label>
									<input
										type="password"
										placeholder="Type your password"
										name="password"
										value={password}
										onBlur={() => handleBlurEvent('password')}
										onChange={(e) => setPassword(e.target.value)}
										autoComplete="new-password"
									/>
									{error.password && <p className="error">{error.password}</p>}
								</div>
							</div>
							<div className="col-md-6 pl-10">
								<div className="form-group">
									<label htmlFor="password">Confiirm password</label>
									<input
										type="password"
										placeholder="Type your password again"
										name="password"
										value={confirmPassword}
										onBlur={() => handleBlurEvent('confirmPassword')}
										onChange={(e) => setConfirmPassword(e.target.value)}
									/>
									{error.confirmPassword && (
										<p className="error">{error.confirmPassword}</p>
									)}
								</div>
							</div>
						</div>

						<div className="row mb-3">
							<div className="col-md-12 text-right">
								<button className="button gray-outline mr-1 size32" onClick={onReset}>
									Reset
								</button>
								<button className="button ml-1 size32" onClick={addAdminInfo}>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default AddAdmin;
